'use client';

import { chatMessagesType } from '@/type/chat';
import { createContext, ReactNode, useContext, useEffect, useRef, useState } from 'react';
import { RefContext } from './refContext';
import { AuthContext } from './authContext';

interface ChatTypes {
    messages: chatMessagesType | undefined
    del_id: number | undefined
    Send: (message: string) => void
}
export const ChatContext = createContext<ChatTypes>({ messages: undefined, Send: () => { }, del_id: -1 })

export default function WebSocketClient({ children }: { children: ReactNode }) {
    const socketRef = useRef<WebSocket | null>(null);
    const [messages, setMessages] = useState<chatMessagesType>();
    const [del_id, setDel_id] = useState<number>(-1);

    const { user, loading } = useContext(AuthContext);
    const { currentUrl, prevUrl } = useContext(RefContext);
    useEffect(() => {
        if (!socketRef.current) return;
        if (socketRef.current.readyState !== WebSocket.OPEN) return;
        socketRef.current.send(JSON.stringify({
            action: "page_check",
            url: currentUrl,
            ref: prevUrl
        }));
    }, [currentUrl]);


    function Send(message: string) {
        socketRef.current?.send(JSON.stringify({ message: message }))
    }


    useEffect(() => {
        if (loading) return;

        if (!user?.is_authenticated) {
            if (socketRef.current) {
                console.log("Chat WebSocket disconnected (logout)");
                socketRef.current.close();
                socketRef.current = null;
            }
        }
        // 재연결 방지
        if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
            return;
        }



        const host = process.env.NODE_ENV === 'development' ? "127.0.0.1:8000" : window.location.host
        // const host = process.env.NODE_ENV === 'development' ? "spottv.ap-northeast-2.elasticbeanstalk.com" : window.location.host
        const protocol = window.location.protocol === "https:" ? 'wss' : 'ws'
        const socketURL = `${protocol}://${host}/ws/chat/`

        const socket = new WebSocket(socketURL);
        socketRef.current = socket;

        socket.onopen = () => {
            // console.log('Chat WebSocket connected');
            socket.send(JSON.stringify({
                action: "page_check",
                // url: window.location.pathname,
                // ref: document.referrer
                url: currentUrl,
                ref: prevUrl
            }));
        };

        socket.onmessage = (e) => {
            const data = JSON.parse(e.data)
            const type = data.type
            // console.log(data)
            switch(type){
                case "chat_message":
                    // 새 메세지
                    setMessages(data);
                    break;
                case "del_message":
                    // 제거 메세지
                    setDel_id(data.msg_id)
                    break;
            }
        };

        socket.onclose = () => {
            // console.log('Chat WebSocket disconnected');
        };

        return () => {
            // socket.close();
            socketRef.current?.close();
            socketRef.current = null;
        };
    }, [user, loading]); 

    const contextValue = {
        messages,
        del_id,
        Send
    }

    return (
        <ChatContext.Provider value={contextValue}>{children}</ChatContext.Provider>
    );
};
